
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { auth } from './firebase';

export default function Terms() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);
  
  const handleBack = () => {
    navigate(user ? '/' : '/login');
  };
  
  return (
    <div style={styles.container}>
      <button onClick={handleBack} style={styles.backButton}>
        <IoArrowBack size={24} />
      </button>
      <p style={styles.updateDate}>{t('legal.lastUpdated')} 20 {t('legal.september')} 2025</p>

      <h1 style={styles.title}>{t('legal.termsAndConditions')}</h1>

      <p style={styles.text}>
        {t('legal.termsDescription')}
      </p>

      <h2 style={styles.subtitle}>1. {t('legal.serviceDescription')}</h2>
      <p style={styles.text}>
        {t('legal.serviceDescriptionText')}
      </p>

      <h2 style={styles.subtitle}>2. {t('legal.userAccounts')}</h2>
      <p style={styles.text}>
        {t('legal.userAccountsDescription')}
      </p>

      <h2 style={styles.subtitle}>3. {t('legal.appUsage')}</h2>
      <p style={styles.text}>
        {t('legal.appUsageDescription')}
      </p>

      <h2 style={styles.subtitle}>4. {t('legal.userContent')}</h2>
      <p style={styles.text}>
        {t('legal.userContentDescription')}
      </p>

      <h2 style={styles.subtitle}>5. {t('legal.contentGuidelines')}</h2>
      <p style={styles.text}>
        {t('legal.contentGuidelinesDescription')}
      </p>

      <h2 style={styles.subtitle}>6. {t('legal.socialFeatures')}</h2>
      <p style={styles.text}>
        {t('legal.socialFeaturesDescription')}
      </p>

      <h2 style={styles.subtitle}>7. {t('legal.premiumServices')}</h2>
      <p style={styles.text}>
        {t('legal.premiumServicesDescription')}
      </p>

      <h2 style={styles.subtitle}>8. {t('legal.intellectualProperty')}</h2>
      <p style={styles.text}>
        {t('legal.intellectualPropertyDescription')}
      </p>

      <h2 style={styles.subtitle}>9. {t('legal.serviceAvailability')}</h2>
      <p style={styles.text}>
        {t('legal.serviceAvailabilityDescription')}
      </p>

      <h2 style={styles.subtitle}>10. {t('legal.accountTermination')}</h2>
      <p style={styles.text}>
        {t('legal.accountTerminationDescription')}
      </p>

      <h2 style={styles.subtitle}>11. {t('legal.liability')}</h2>
      <p style={styles.text}>
        {t('legal.liabilityDescription')}
      </p>

      <h2 style={styles.subtitle}>12. {t('legal.disputeResolution')}</h2>
      <p style={styles.text}>
        {t('legal.disputeResolutionDescription')}
      </p>

      <h2 style={styles.subtitle}>13. {t('legal.termsChanges')}</h2>
      <p style={styles.text}>
        {t('legal.termsChangesDescription')}
      </p>

      <h2 style={styles.subtitle}>14. {t('legal.governingLaw')}</h2>
      <p style={styles.text}>
        {t('legal.governingLawDescription')}
      </p>

      <h2 style={styles.subtitle}>15. {t('legal.contact')}</h2>
      <p style={styles.text}>
        {t('legal.termsContact')} <b>support@wishareapp.com</b>
      </p>

      <hr style={styles.divider} />
      <p style={styles.footer}>© 2025 Wishare. {t('legal.allRightsReserved')}</p>
    </div>
  );
}

const styles = {
  container: {
    padding: "24px",
    paddingTop: "calc(env(safe-area-inset-top, 0px) + 72px)",
    backgroundColor: "#fff",
    fontFamily: "Poppins, sans-serif",
    color: "#111",
    minHeight: "100vh",
    paddingBottom: "80px",
    position: "relative",
  },
  backButton: {
    position: "absolute",
    top: "calc(env(safe-area-inset-top, 0px) + 50px)",
    left: "16px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#111",
    zIndex: 20,
  },
  updateDate: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "16px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "24px",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "20px",
    marginBottom: "10px",
  },
  text: {
    fontSize: "14px",
    lineHeight: "1.7",
    marginBottom: "12px",
  },
  divider: {
    marginTop: "40px",
    borderTop: "1px solid #ddd",
  },
  footer: {
    fontSize: "12px",
    color: "#666",
    marginTop: "12px",
  },
};
